import type { CreateExpenseRequest, ExpenseResponse, ExpenseSummaryResponse } from "@qota/shared";
import { request } from "./http";

export function listExpenses(groupId: string): Promise<ExpenseSummaryResponse[]> {
  return request<ExpenseSummaryResponse[]>("GET", `/groups/${groupId}/expenses`);
}

export function getExpense(groupId: string, expenseId: string): Promise<ExpenseResponse> {
  return request<ExpenseResponse>("GET", `/groups/${groupId}/expenses/${expenseId}`);
}

export function createExpense(
  groupId: string,
  input: CreateExpenseRequest,
): Promise<ExpenseResponse> {
  return request<ExpenseResponse>("POST", `/groups/${groupId}/expenses`, input);
}

export function updateExpense(
  groupId: string,
  expenseId: string,
  input: CreateExpenseRequest,
): Promise<ExpenseResponse> {
  return request<ExpenseResponse>("PUT", `/groups/${groupId}/expenses/${expenseId}`, input);
}

export function deleteExpense(groupId: string, expenseId: string): Promise<void> {
  return request<void>("DELETE", `/groups/${groupId}/expenses/${expenseId}`);
}
